<template>
  <div class="sync">
    <div class="sync__syncing">СИНХРОНИЗАЦИЯ</div>
    <div class="sync__progress">
      <div class="sync__progress__cached" :style="{ width: cachedWidth }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncPage',
  computed: {
    cachedWidth() {
      const { downloadSize, totalSize } = this.$cacheService.cachingProgress;
      const rawValue = (downloadSize * 100) / totalSize;
      return `${rawValue}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.sync {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  background-color: #4b4b4b;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__syncing {
    color: white;
    font-size: 10vh;
    text-align: center;
  }

  &__progress {
    width: 80vw;
    height: 10vh;
    margin-top: 5vh;

    border: 0.3vh solid #fb9827;
    border-radius: 1vh;

    &__cached {
      width: 0;
      height: 100%;
      background-color: #fb9827;
      border-radius: 0.6vh;

      transition: all linear 0.1s;
    }
  }
}

@media (orientation: portrait) {
  .sync {
    &__syncing {
      color: white;
      font-size: 5vh;
      text-align: center;
    }

    &__progress {
      height: 5vh;

      margin-top: 3vh;
    }
  }
}
</style>
